import request, { serviceV2 } from '@/utils/request'

const prefix = '/django_rest/ai'
const serviceV2Prefix = '/ai'

export default {
  createAISummary (params) {
    return request.post(`${prefix}/summary/`, params)
  },
  updateAISummary (params) {
    return request.put(`${prefix}/summary/`, params)
  },
  getAISummaryInfoByTaskId (taskId) {
    return request.get(`${prefix}/summary/${taskId}/`)
  },
  createAIResumeMatch (params) {
    return request.post(`${prefix}/resume-match/`, params)
  },
  getAIMatchInfoByTaskId (taskId) {
    return request.get(`${prefix}/resume-match/${taskId}/`)
  },
  createAIComparison (params) {
    return request.post(`${prefix}/resume-comparison/`, params)
  },
  getAIComparisonInfoByTaskId (taskId) {
    return request.get(`${prefix}/resume-comparison/${taskId}/`)
  },
  getAIComparisonHistory (params) {
    return request.get(`${prefix}/resume-comparison/history/`, { params })
  },
  getAIComparisonHistoryInfoById (historyId) {
    return request.get(`${prefix}/resume-comparison/history/${historyId}/`)
  },
  getAIAgentList (params) {
    return serviceV2.get(`${serviceV2Prefix}/ai-agent/`, { params })
  },
  getAIAgentInfoById (agentId) {
    return serviceV2.get(`${serviceV2Prefix}/ai-agent/${agentId}/`)
  },
  getAIModelList () {
    return serviceV2.get(`${serviceV2Prefix}/ai-model/`)
  },
  updateAIAgent (data) {
    return serviceV2.post(`${serviceV2Prefix}/ai-agent/${data.id}/`, data)
  }
}
